import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";

const state = {
  periods: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_PERIODS_BUSY: (state, payload) => {
    state.periods.isBusy = payload;
  },
  LOAD_PERIODS_SUCCESS: (state, payload) => {
    state.periods.isBusy = false;
    state.periods.data = payload.data;
    state.periods.error = null;
  },
  LOAD_PERIODS_FAIL: (state, payload) => {
    state.periods.isBusy = false;
    state.periods.data = null;
    state.periods.error = payload;
  },
  SET_CUSTOM_PERIODS: (state, payload) => {
    state.periods.data.periods = payload
  }
};

const actions = {
  getPeriods: ({ commit, rootState }, { projectId , queryId}) => {
    commit('LOAD_PERIODS_BUSY', true);

    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };

    Axios
      .get(`${API_HOST}/projects/${projectId}/queries/${queryId}/periods`, config)
      .then((response)=> {
        commit('LOAD_PERIODS_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_PERIODS_FAIL', error)
      });
  },
  udpateCustomPeriods({ commit, rootState, state }, { projectId , queryId, periods}) {
    commit('LOAD_PERIODS_BUSY', true);

    const config = {
      headers: { 'Authorization': setAccessToken(rootState) },
    };

    return new Promise ((resolve, reject) => {
      Axios
        .put(`${API_HOST}/projects/${projectId}/queries/${queryId}/periods`, periods, config)
        .then((response)=> {
          commit('LOAD_PERIODS_SUCCESS', response.data);
          resolve(response.data.data.periods);
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')});
  
          console.error(error);
          commit('LOAD_PERIODS_FAIL', error);
          reject(error);
        });
    }); 
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};